<template>
  <section>
    <BasicVideoPicsTextSwiper :title="title" :subtitle="subtitle" :imgs="imgs" id="11"></BasicVideoPicsTextSwiper>
  </section>
</template>
<script>
import BasicVideoPicsTextSwiper from '@/components/basic-videopicstext-swiper.vue'
export default {
  data() {
    return {
      title: '内外兼修',
      subtitle:'为您带来全面升级的感官体验',
      imgs: [
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/1.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/mob/1.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '哈曼卡顿音响系统(8扬声器)',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/4.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/mob/4.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '专属饰条',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/3.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/mob/3.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '专属金属迎宾踏板',
          text: "",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/6.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/mob/6.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: '专属座椅',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/2.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/mob/2.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '专属黑色顶棚',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/5.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/gtlineinner/mob/5.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img3.png',
          title: 'GT-Line专属标志(头枕)',
          // text: "通过控制加速踏板实现加速、减速、停车的单踏板模式",
          type: 'img'
        }
      ],
    }
  },
  components: {
    BasicVideoPicsTextSwiper
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.my-weiper-container-mob{
  .swiper-pagination11 {
    top: calc(300 / 375 * 100vw) !important;
  }
}
</style>
